import { useQuery, UseQueryResult } from 'react-query';
import { client } from 'utils/api-client';

export interface GHLPipelineStage {
  id: string;
  name: string;
}

export interface GHLPipeline {
  id: string;
  name: string;
  stages: GHLPipelineStage[];
}

async function fetchPipelines(): Promise<GHLPipeline[]> {
  const { data } = await client.get<GHLPipeline[]>('glm-kilo-flows/pipelines/');
  return data;
}

export default function usePipelines(enabled = true): UseQueryResult<GHLPipeline[]> {
  return useQuery({
    queryKey: ['ghl-pipelines'],
    queryFn: fetchPipelines,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
